let rpcMode = 0;
export function setRpcMode(mode) {
    if (mode == 0) {
        return;
    }
    rpcMode = mode;
    window.localStorage.setItem("rpcMode", rpcMode.toString());
}
export function getServerUrl() {
    var _a;
    if (rpcMode == 0) {
        rpcMode = parseInt((_a = window.localStorage.getItem('rpcMode')) !== null && _a !== void 0 ? _a : "1");
    }
    switch (rpcMode) {
        case 2:
            return 'https://devbackend.loder.app';
        case 3:
            return 'http://localhost:5000';
        default:
            return 'https://backend.loder.app';
    }
}
let currentAccessToken = '';
let currentRefreshToken = '';
export async function rpcCall(fName, ...args) {
    var _a, _b;
    if (!currentAccessToken) {
        currentAccessToken = (_a = window.localStorage.getItem('accessToken')) !== null && _a !== void 0 ? _a : '';
    }
    // console.log(currentAccessToken)
    const bruh = `${getServerUrl()}/api/rpc/${fName}`;
    let response = await fetch(bruh, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Cadmean-RPC-Version': '2.1'
        },
        body: JSON.stringify({
            "args": args,
            "auth": currentAccessToken,
        })
    });
    if (!response.ok) {
        throw new Error(`RPC call failed: ${response.statusText}`);
    }
    let json = await response.json();
    if (json.error != 0) {
        throw json.error;
    }
    if (((_b = json.metaData) === null || _b === void 0 ? void 0 : _b.resultType) == 'auth') {
        currentAccessToken = json.result['accessToken'];
        currentRefreshToken = json.result['refreshToken'];
        window.localStorage.setItem('refreshToken', currentRefreshToken);
    }
    return json.result;
}
export function rpcClearAuth() {
    currentAccessToken = '';
    currentRefreshToken = '';
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('refreshToken');
}
